(function() {
  if (window._swipercoverflowLoaded) return;
  window._swipercoverflowLoaded = true;

class SwiperCoverflow extends HTMLElement {
  constructor() {
    super();
    // eslint-disable-next-line no-unused-vars
    this.dataset.enableShadows === 'true';

    const swiperCoverflow = new Swiper('.swiperCF', {
      slidesPerView: 1.25,
      centeredSlides: true,
      loop: false,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination-coverflow',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      mousewheel: {
        forceToAxis: true,
      },

      breakpoints: {
        640: {
          slidesPerView: 1.25,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 30,
        },
      },
    });
    if (swiperCoverflow.slides)
      swiperCoverflow.slideTo(swiperCoverflow.slides.length / 2, 0, false);
  }
}

if (!customElements.get('swiper-coverflow'))
  customElements.define('swiper-coverflow', SwiperCoverflow);

})();